<template>
    <v-container>
      <loader-dialog :showLoader="loading" message="Carregando avisos..."/>
      <header-for-list-component
        sectionName="Avisos"
        :items="activeItems"
        :totalItems="totalItems"
        :totalPages="totalPages"
        :itemsPerPage="itemsPerPage"
        :pageNumber.sync="pageNumber"
        @loadPage="loadPage($event)"
      />
  
  
      <v-layout align-center class="mb-4">
        <v-flex xs4>
          <v-text-field
            v-model="search"
            solo
            label="Buscar Aviso"
            prepend-inner-icon="search"
            hide-details
            :loading="loadingSearch"
            @input="typing()"
          >
            <template v-slot:progress>
              <v-progress-linear
                v-if="loadingSearch"
                color="accent"
                indeterminate
                height="3"
              ></v-progress-linear>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex xs8></v-flex>
        <v-flex>
          <v-btn flat color="docgo" @click.stop="newNotice()">
            <v-icon class="pr-2">
              mdi-account-multiple-plus
            </v-icon>
            Novo Aviso
          </v-btn>
        </v-flex>
      </v-layout>
  
      <v-layout>
        <v-flex xs12>
          <v-card>
            <div v-if="activeItems.length === 0">
              <h4 style="text-align: center" class="pa-3">Nenhum aviso encontrado com o termo buscado</h4>
            </div>
  
            <v-data-table
              v-else
              :headers="headers"
              :items="activeItems"
              hide-actions
              class="elevation-1"
            >
              <template v-slot:items="props">
                <tr style="cursor: default">
                  <td>
                    <span class="">{{ props.item.id }}</span>
                  </td>
                  <td>
                    <span class="">{{ props.item.title }}</span>
                  </td>
                  <td>
                    <span class="">{{ props.item.body }}</span>
                  </td>
                  <td>
                    <span class="">{{ props.item.user.name }}</span>
                  </td>
                  <td>
                    <span class="">{{ isActive(props.item.active) }}</span>
                  </td>
                  <td class="text-xs-right action-icons">
                    <v-layout class="d-inline-flex">
                      <v-btn
                        icon
                        flat
                        class="mx-0"
                        @click.stop="editNotice(props.item)"
                      >
                        <v-icon small>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </v-layout>
                  </td>
                </tr>
              </template>
            </v-data-table>
  
            <notice-form :dialog.sync="showDialogNotice" @updateList="loadPage()"/>
          </v-card>
        </v-flex>
      </v-layout>
  
    </v-container>
  </template>
  
  <script>
    import HeaderForListComponent from "@/components/settings/HeaderForListComponent";
    import LoaderDialog from '@/components/LoaderDialog';
    import NoticeService from '@/services/system/NoticeService';
    import NoticeForm from '@/components/notice/NoticeForm';
  
    export default {
      components: {
        LoaderDialog,
        HeaderForListComponent,
        NoticeForm
      },
      name: "notices",
      data() {
        return {
          headers: [
            {text: 'ID', sortable: true, value: 'id', align: 'left'},
            {text: 'Título', sortable: false, value: 'name', align: 'left'},
            {text: 'Mensagem', sortable: false, value: 'body', align: 'left'},
            {text: 'Criado por', sortable: false, value: 'user_name', align: 'left'},
            {text: 'Ativo', sortable: false, value: 'body', align: 'left'},
          ],
          activeItems: [],
          showDialogNotice: false,
          loading: false,
          loadingSearch: false,
          totalItems: 0,
          totalPages: 0,
          itemsPerPage: 20,
          pageNumber: 1,
          search: '',
          interval: null,
        };
      },
      mounted() {
        this.loadPage(1);
      },
      methods: {
        loadPage(pageNumber) {
          this.pageNumber = pageNumber || this.pageNumber;
          if (!this.loadingSearch) this.loading = true;
  
          NoticeService.all({
            limit: this.itemsPerPage,
            page: this.pageNumber,
            q: this.search,
          })
            .then(({data}) => {
              this.activeItems = data.notices;
              this.totalItems = data.total;
              this.totalPages = data.total_pages;
            })
            .catch(({response}) => {
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'error',
                message: response.data,
                messageIcon: 'mdi-check',
              });
            })
            .finally(() => {
              this.loading = false;
              this.loadingSearch = false;
            });
        },
        typing() {
          clearInterval(this.interval)
          this.interval = setTimeout(() => {
            this.loadingSearch = true;
            this.pageNumber = 1;
            this.loadPage();
          }, 500);
        },
        editNotice(notice) {
          this.$store.dispatch('setNotice', notice);
          this.showDialogNotice = true;
        },
        newNotice() {
          this.$store.dispatch('setNotice', {});
          this.showDialogNotice = true;
        },
        isActive(active) {
          return active ? 'Sim' : 'Não';
        }
      }
    };
  </script>
  
  <style lang="scss" scoped>
    .inactive{
      & > * {
        text-decoration: line-through;
      }
    }
  
    .action-icons{
      text-decoration: none !important;
    }
  </style>
  


// WEBPACK FOOTER //
// src/views/settings/notices/List.vue